<script lang="ts">
    import { setTypedContext } from "@lib/svelte-typed-context";
    import { onMount } from "svelte";

    import { masonryControllerToken } from "./context_tokens";
    import MasonryController from "./MasonryController";

    export let controller: MasonryController;
    export let rowHeight = 20;
    export let rowGap = 10;
    setTypedContext(masonryControllerToken, controller);
    onMount(() => {
        controller.setRowHeight(rowHeight);
        controller.setRowGap(rowGap);
        controller.update();
    });
</script>

<svelte:window on:resize={() => controller.update()} />

<div class="gw-masonry">
    <ul
        class="gw-masonry__grid"
        style="--gw-masonry-row-height: {rowHeight}px; --gw-masonry-gap: {rowGap}px;"
    >
        <slot />
    </ul>
</div>

<style>
    .gw-masonry__grid {
        --gw-masonry-columns-count: auto-fill;
        --gw-masonry-columns-width: minmax(250px, 1fr);
        display: grid;
        grid-template-columns: repeat(
            var(--gw-masonry-columns-count),
            var(--gw-masonry-columns-width)
        );
        grid-auto-rows: var(--gw-masonry-row-height);
        gap: var(--gw-masonry-gap);

        margin: 0;
        padding: 0;
        list-style: none;
    }
</style>
